import {
  teammateIdSchema,
  type TeammateId,
} from "@repo/app-types/entities/teammate";
import { useMatch } from "react-router";
import { appPaths } from "../app/appPaths.js";

/**
 * The teammate the current URL is scoped to, for app chrome that renders
 * outside the route outlet (the search dialog): those components sit above the
 * routes, so they read the teammate from the URL rather than from props.
 *
 * Every route family carrying a `:teammateId` is matched, not only the teammate
 * page — a criterion drill-down is as much "this teammate" as their own page is.
 * `undefined` for every other URL.
 */
export function useTeammateIdParam(): TeammateId | undefined {
  const teammatePageMatch = useMatch(`${appPaths.teammate.pattern}/*`);
  const criterionTeammateMatch = useMatch(
    `${appPaths.playbookCriterionTeammate.pattern}/*`,
  );
  // The teammate agent's criterion drill-down, which has no path of its own in
  // `appPaths` — only the call below it does.
  const agentCriterionMatch = useMatch(
    `${appPaths.teammateAgent.pattern}/overview/teammates/:teammateId/*`,
  );

  return teammateIdSchema.safeParse(
    (teammatePageMatch ?? criterionTeammateMatch ?? agentCriterionMatch)?.params
      .teammateId,
  ).data;
}
